import React, { useState } from "react";
import Button from "./forms/Button";
import ModalNew from "../Modal/ModalNew";
import { cancelSubscription } from "../../services/api/billing";

const UnsubscribeButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleUnsubscribe = async () => {
    setLoading(true);
    try {
      await cancelSubscription();
      setIsOpen(false);
      // Optionally reload or redirect
      window.location.reload();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        title="Cancel Subscription"
        onSubmitHandler={() => setIsOpen(true)}
        className="bg-red-500 text-white border-red-500 hover:bg-red-600 hover:text-white hover:border-red-600 !w-auto !h-[40px] text-sm flex"
      />

      <ModalNew
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Unsubscribe Plan"
      >
        <div className="flex flex-col gap-4">
          <p className="text-gray-600">
            Are you sure you want to unsubscribe? You will lose access to
            premium features at the end of your current billing period.
          </p>

          <div className="flex gap-3 justify-end mt-4">
            <button
              onClick={() => setIsOpen(false)}
              className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              onClick={handleUnsubscribe}
              disabled={loading}
              className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50 flex items-center gap-2"
            >
              {loading ? "Processing..." : "Confirm Unsubscribe"}
            </button>
          </div>
        </div>
      </ModalNew>
    </>
  );
};

export default UnsubscribeButton;
